module.exports = "/_next/static/images/CollectAndBuild@2x-6b2650053ee786ff310f8d80ade9fb15.png";